import { render } from "./Layout3.vue?vue&type=template&id=464c5fa2&ts=true"
import script from "./Layout3.vue?vue&type=script&lang=ts"
export * from "./Layout3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__